import { render } from "./PrintResume.vue?vue&type=template&id=5dd92bbc"
import script from "./PrintResume.vue?vue&type=script&lang=js"
export * from "./PrintResume.vue?vue&type=script&lang=js"

import "./PrintResume.vue?vue&type=style&index=0&id=5dd92bbc&lang=css"
script.render = render

export default script